import { ImportCSVForm, RowData } from '@components/process-import-csv/src/process-import-csv.type';
import { ImportFormData } from '@hooks/import/type';

import {
  FIELD_EMAIL,
  FIELD_FIRST_NAME,
  FIELD_FULL_NAME,
  FIELD_LANGUAGE,
  FIELD_LAST_NAME,
  FIELD_NATIONALITY,
  FIELD_PHONE,
  FIELD_QR_CODE,
} from './validate-import-csv';

const isKeyOfRowData = (key: string): key is keyof RowData => {
  return [
    FIELD_FIRST_NAME,
    FIELD_LAST_NAME,
    FIELD_FULL_NAME,
    FIELD_PHONE,
    FIELD_LANGUAGE,
    FIELD_NATIONALITY,
    FIELD_EMAIL,
  ].includes(key);
};

export const formatCsvFormToBackend = (
  formData: ImportCSVForm & { columns: { field: string }[] },
  processedColumns: string[][]
): ImportFormData => {
  const { columns: formDataColumns } = formData;
  return {
    eventId: formData.eventId,
    offerId: formData.offerId,
    channelId: formData.channelId,
    rows: (processedColumns[0] as string[]).map((_, rowIndex) => {
      const qrCode = processedColumns[formDataColumns.findIndex((col) => col?.field === FIELD_QR_CODE)]?.[
        rowIndex
      ] as string;
      const rowData: RowData = {
        row: rowIndex + 1,
        qrCode,
      };
      formDataColumns.forEach((col, colIndex) => {
        if (col.field && col.field !== FIELD_QR_CODE && isKeyOfRowData(col.field)) {
          // eslint-disable-next-line
          // @ts-ignore
          rowData[col.field] = processedColumns[colIndex][rowIndex] as string;
        }
      });

      return rowData;
    }),
  };
};
